import { EnvironmentConfigurationError, assertAppCheckEnvironment, assertRuntimeFirebaseProject, parseAppCheckEnforcementMode, parseRuntimeEnvironment, requireEnvironmentValue, } from "./environment.js";
export const canonicalProductionFirebaseProjectId = "shdeed-prod";
export const productionDeploymentConfirmationPhrase = "deploy-production-shdeed-prod";
export const productionDeploymentOperations = [
    "preflight",
    "firestore",
    "storage",
    "functions",
    "hosting",
    "all",
];
const productionDeploymentOperationSet = new Set(productionDeploymentOperations);
export function validateProductionDeploymentGuard(input) {
    const environment = parseRuntimeEnvironment(input.environment);
    if (environment !== "production") {
        throw new EnvironmentConfigurationError("Production deploy guard must run with APP_ENVIRONMENT=production.");
    }
    const operation = parseProductionDeploymentOperation(input.operation);
    const projectId = requireEnvironmentValue(input.projectId, "FIREBASE_PROJECT_ID");
    if (projectId !== canonicalProductionFirebaseProjectId) {
        throw new EnvironmentConfigurationError(`Production deploy guard must target ${canonicalProductionFirebaseProjectId}.`);
    }
    assertRuntimeFirebaseProject({
        environment,
        configuredProjectId: projectId,
        runtimeProjectId: input.runtimeProjectId,
    });
    if (input.useEmulators || hasConfiguredEmulatorHost(input.emulatorHosts)) {
        throw new EnvironmentConfigurationError("Production deploy guard refuses Firebase emulator configuration.");
    }
    if (input.cloudSeedConfirmationProjectId !== undefined &&
        input.cloudSeedConfirmationProjectId.trim() !== "") {
        throw new EnvironmentConfigurationError("Production deploy guard refuses seed confirmation variables.");
    }
    const confirmation = requireEnvironmentValue(input.confirmation, "SHDEED_PRODUCTION_DEPLOY_CONFIRM");
    if (confirmation !== productionDeploymentConfirmationPhrase) {
        throw new EnvironmentConfigurationError(`SHDEED_PRODUCTION_DEPLOY_CONFIRM must exactly equal ${productionDeploymentConfirmationPhrase}.`);
    }
    const approvedBy = requireEnvironmentValue(input.approvedBy, "SHDEED_PRODUCTION_APPROVED_BY");
    const appCheckMode = parseAppCheckEnforcementMode(input.appCheckMode);
    assertAppCheckEnvironment({ environment, mode: appCheckMode });
    return {
        appCheckMode,
        approvedBy,
        environment,
        operation,
        projectId: canonicalProductionFirebaseProjectId,
    };
}
function parseProductionDeploymentOperation(value) {
    const operation = requireEnvironmentValue(value, "production deployment operation").toLowerCase();
    if (productionDeploymentOperationSet.has(operation)) {
        return operation;
    }
    throw new EnvironmentConfigurationError(`Production deployment operation must be one of: ${productionDeploymentOperations.join(", ")}.`);
}
function hasConfiguredEmulatorHost(emulatorHosts) {
    if (!emulatorHosts) {
        return false;
    }
    return Object.values(emulatorHosts).some((value) => value !== undefined && value.trim() !== "");
}
